import styled from 'styled-components';

export const EmptyCartNotificationWrapper = styled.div`
  min-width: 700px;
`;
